// Legal document versions and content configuration
// Update these versions when legal documents are updated to trigger re-consent

export const LEGAL_VERSIONS = {
  TERMS: 'v1.7',
  PRIVACY: 'v1.5',
  COOKIES: 'v1.3',
};

/** Shown on legal pages — update when terms/privacy/cookies change materially. */
export const LEGAL_LAST_UPDATED = {
  TERMS: '26 May 2026',
  PRIVACY: '26 May 2026',
  COOKIES: '26 May 2026',
};

// Legal document content - easy to edit and maintain
export const LEGAL_CONTENT = {
  COMPANY_INFO: {
    name: 'Trackio Ltd',
    registrationNumber: 'NI735423',
    address: 'Northern Ireland, United Kingdom',
    email: 'support@trackio.co.uk',
    dataProtectionEmail: 'support@trackio.co.uk'
  },

  TERMS_SUMMARY:
    'Our Terms & Conditions outline your rights and responsibilities when using Trackio Document Pack in the UK, US, Canada, Australia, and elsewhere: organising business documents, subscription plans (Free, Solo, Business), billing via Stripe or app stores, acceptable use, product changes, and service limitations.',

  PRIVACY_SUMMARY:
    'Our Privacy Policy explains how we collect, use, and protect your data when you use Trackio—including rights under UK GDPR, US state privacy laws, PIPEDA (Canada), and the Australian Privacy Act. Covers anonymous try, AI extraction, Stripe and app-store billing, and secure storage when you have an account.',
  
  COOKIES_SUMMARY:
    'We use essential cookies for authentication and security, optional analytics with consent, and tools such as Stripe and hCaptcha (anonymous try on the web). You can control preferences at any time.',
};

// Cookie categories for consent management
export const COOKIE_CATEGORIES = {
  ESSENTIAL: {
    name: 'Essential Cookies',
    description: 'Required for basic website functionality, authentication, and security.',
    required: true,
    cookies: [
      'Authentication tokens',
      'Session management',
      'Security preferences',
      'CSRF protection',
      'Browser storage used to resume Document Pack or bulk try flow (e.g. after sign-up)',
    ],
  },
  ANALYTICS: {
    name: 'Analytics Cookies',
    description: 'Help us understand how you use Trackio to improve our service.',
    required: false,
    cookies: [
      'Usage statistics',
      'Performance monitoring', 
      'Error tracking',
      'Feature usage analytics'
    ]
  }
};